import type { InfoPanel } from "./form-types";

import { getHeroVariantStyles } from "../CareSeeker/shared/hero-variants";

function getInfoPanelHeroStyles(infoPanel: InfoPanel | null | undefined) {
  if (infoPanel?.mode !== "hero") {
    return getHeroVariantStyles("default");
  }

  return getHeroVariantStyles(infoPanel.variant ?? "default");
}

export { getInfoPanelHeroStyles };
